/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_Min_Spend_LabelInputs */

const vi_shop_tier_min_spend_label = /** @type {(inputs: Shop_Tier_Min_Spend_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mốc chi tiêu tối thiểu`)
};

/**

* @param {Shop_Tier_Min_Spend_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_min_spend_label = /** @type {((inputs?: Shop_Tier_Min_Spend_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Min_Spend_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_min_spend_label(inputs)
});